import { mapGetters, mapMutations } from 'vuex';
import { getChannelInfo } from '@/api/apiAll';
import ROP from '@/utils/Rop';

const mixin = {
  data() {
    return {
      dmsTimer: null,
      counter: 0,
    };
  },
  watch: {
    'channelInfo.uin'() {
      this._DMSInit();
      this._enterDms();
    },
  },
  // async mounted() {
  //   this._DMSInit();
  //   this._enterDms();
  // },
  computed: {
    ...mapGetters({
      status: 'status',
      channelInfo: 'channelInfo',
      uuid: 'uuid',
    })
  },
  methods: {
    ...mapMutations({
      set_channelInfo: 'set_channelInfo'
    }),
    _enterDms() {
      clearTimeout(this.dmsTimer);
      this.dmsTimer = setTimeout(() => {
        if (this.uuid) {
          this._makeClientId();
          clearTimeout(this.dmsTimer);
        } else {
          if (this.counter > 20) {
            clearTimeout(this.dmsTimer);
            console.error('[Mixin] _enterDms() - uuid is not found');
            return
          }
          this._enterDms();
          this.counter++;
        }
      }, 500);
    },
    _makeClientId() {
      ROP.Leave();
      ROP.Enter('', this.channelInfo.sub_key, this.uuid, true);
    },
    _DMSInit() {
      let self = this;
      // chat连接成功后的消息
      ROP.On('enter_suc', function() {
        console.log('服务器连接成功');
        ROP.Subscribe(self.channelInfo.dmsTopic);
        ROP.Subscribe(self.channelInfo.dmsDataTopic);
        ROP.Subscribe('sys/notify/lss');
      });
      ROP.On('reconnect', function(err) {
        console.log('重连', err);
      });
      // chat连接失败后的消息
      ROP.On('enter_fail', function(err) {
        console.log('服务器连接失败', err);
      });
      // chat接收到的消息
      ROP.On('publish_data', function(res, topic) {
        let data = JSON.parse(res);
        switch (topic) {
          case self.channelInfo.dmsTopic:
            self._dmsChat(data);
            break;
          case self.channelInfo.dmsDataTopic:
            self._dmsChannelInfo(data);
            break;
          case 'sys/notify/lss':
            self._liveStatus(data);
            break;
          default:
            break;
        }
      });
      // chat断开连接后的消息
      ROP.On('losed', function() {
        console.log('服务器断开连接');
      });
    },
    _dmsChat(data) {
      if (Number(data.msgType) === 1) {
        this.$Bus.$emit('bus-sendBarrage', data.filterContent);
      }
      if (data.isTop) {
        this.$Bus.$emit('bus-addTopChat', data);
      }
      this.$Bus.$emit('bus-addChat', data);
    },
    _dmsChannelInfo(data) {
      if (data.cmd === 'watchNum') {
        // 自定义观看量
        this.$Bus.$emit('bus-customWatchNum', data.watchNum);
        return false;
      }
      if (data.cmd === 'realWatchNum') {
        // 真实观看量
        this.$Bus.$emit('bus-realWatchNum', data.realWatchNum);
        return false;
      }
      if (data.cmd === 'isTop') {
        // 是否置顶
        if (Number(data.status) === 0) {
          this.$Bus.$emit('bus-delTopChat', data.chatInfo.id);
        }
        return false;
      }
      if (data.id) {
        // 删除聊天
        this.$Bus.$emit('bus-delTopChat', data.id);
        this.$Bus.$emit('bus-delChat', data.id);
      }
    },
    async _liveStatus(data) {
      if (data.app !== this.channelInfo.lssApp || data.stream !== this.channelInfo.stream) {
        return false;
      }
      if (data.cmd === 'StartPublish') {
        // 二次确认 判断是否是直播流不稳定
        const info = await getChannelInfo({
          id: this.channelInfo.id
        });
        if (info.liveStatus === 1) {
          this.$Bus.$emit('ws-changeLiveNowStatus', 1)
          console.log('liveStatus: 1');
          this.set_channelInfo(info);
        }
      }
      if (data.cmd === 'StopPublish') {
        // 二次确认 判断是否是直播流不稳定
        const info = await getChannelInfo({
          id: this.channelInfo.id
        });
        if (info.liveStatus === 0) {
          this.$Bus.$emit('ws-changeLiveNowStatus', 0)
          console.log('liveStatus: 0');
          this.set_channelInfo(info);
        }
      }
    }
  }
};
export default mixin;
